import React from "react";
import { NavLink } from "react-router-dom";
import { Badge } from "primereact/badge";
import { AiOutlinePlus, AiOutlineLine } from "react-icons/ai";
import Collapse from "react-bootstrap/Collapse";
const lien = "#";

export const LienWithSubMenu = ({
  sethandleMenu,
  menu,
  routesMenu,
  iconeGlobal,
  nameGroupe,
  allPermission,
  notPermission
}) => {
  return (
    <>
    {
      (allPermission || notPermission) && <>
       <li>
        <a
          href={lien}
          onClick={() => sethandleMenu((menu) => menu = !menu)}
          aria-controls="example-collapse-text"
          aria-expanded={menu}
        >
          {iconeGlobal}
          {nameGroupe}
          {menu ? (
            <span className="line-plus">
              <AiOutlineLine />
            </span>
          ) : (
            <span className="line-plus">
              <AiOutlinePlus />
            </span>
          )}
        </a>
      </li>
      <Collapse in={menu}>
        <ul className="example-collapse-text">
          {routesMenu.map((item, index) => (
            <li key={index}>
              <NavLink to={item.route}>
                {item.icone} {item.name}
              </NavLink>
            </li>
          ))}
        </ul>
      </Collapse>
      </>
    }
     
    </>
  );
};
function LienNavLink({ route, icone, nom, isBadge, valueBadge,allPermission,
  notPermission }) {
  return (
    <>
    {
      (allPermission || notPermission)  && <li style={{ position: "relative" }}>
        {isBadge && valueBadge > 0 && (
          <Badge
            value={valueBadge}
            severity="danger"
            style={{ position: "absolute", top: "0", right: 0, zIndex: 999 }}
          ></Badge>
        )}
        <NavLink to={route}>
          {icone} {nom}
        </NavLink>
      </li>
    }
     
    </>
  );
}

export default LienNavLink;
